/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { brands } from "icons";
import { ReactComponent as EnvelopeIcon } from "cms/assets/icons/envelope.svg";

const SocialColumn = () => {
    return (
        <div className='footer-column social-column'>
            <NavLink to='https://www.tol.ca/en/connect/stay-connected.aspx'>
                <h2>Connect with us</h2>
            </NavLink>
            <div className='social-links'>
                <a href="https://www.facebook.com" aria-label="Folow us on Facebook">
                    <FontAwesomeIcon icon={brands.faFacebookF} size={"2x"} />
                </a>
                <a href="https://www.instagram.com" aria-label="Folow us on Instagram">
                    <FontAwesomeIcon icon={brands.faInstagram} size={"2x"} />
                </a>
                <a href="https://www.twitter.com" aria-label="Folow us on Twitter">
                    <FontAwesomeIcon icon={brands.faXTwitter} size={"2x"} />
                </a>
                <a href="https://www.youtube.com" aria-label="Folow us on YouTube">
                    <FontAwesomeIcon icon={brands.faYoutube} size={"2x"} />
                </a>
                <a href="https://www.linkedin.com" aria-label="Folow us on LinkedIn">
                    <FontAwesomeIcon icon={brands.faLinkedinIn} size={"2x"} />
                </a>
            </div>
            <NavLink className='subscribe-btn' to='https://www.tol.ca/en/connect/enewsletter.aspx'>
                <EnvelopeIcon />
                Subscribe to Newsletter
            </NavLink>
        </div>
    );
};

export { SocialColumn };
